/**
 *
 * Asynchronously loads the component for ProfileBankInformation
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
